module.exports = __webpack_public_path__ + "static/media/pc_pic_logon_bg.70b2d381.png";